import React from 'react';
import { autobind } from 'core-decorators';
import CreatableSelect from 'react-select/creatable';
import Select, { components } from 'react-select';
import { FormGroup, FormFeedback } from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import '../../styles/react-select.scss';

import css from '../../utils/css';
import httpSelector from 'src/services/httpSelector';
import ItemMulti from '../item-multi-lookup';
import ContentManager from '../content-manager';
import CopyToClipboard from '../CopyToClipboard';
import Info from '../info';
import CompactMultiValueContainer, {
  compactMultiStyles,
} from '../compact-multi-value';

@autobind
class Select2 extends React.Component {
  static defaultProps = {
    showLabel: true,
    menuPlacement: 'auto',
    menuPosition: 'fixed',
    pageSize: 1000,
    selectNewItem: true,
    moduloLookup: false,
  };

  constructor(props) {
    super(props);

    const { multiValueWrapper } = this.props;
    this.state = {
      data: this.props.options ? this.props.options : [],
      classes: css`
        .select {
          .Select-control {
            /*height: 34px;
          line-height: 30px;*/
            border: 1px solid #dde6e9;

            .Select-multi-value-wrapper {
              ${multiValueWrapper &&
              this.setMultiValueWrapper(multiValueWrapper)}
              .Select-input {
                /*height: 31px;*/
              }
            }
          }
        }
      `,
    };
  }

  setMultiValueWrapper = (multiValueWrapper) =>
    !Array.isArray(multiValueWrapper)
      ? multiValueWrapper
      : multiValueWrapper.join(';');

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      JSON.stringify(newProps.data) !== JSON.stringify(this.props.data) ||
      newProps.saved !== this.props.saved
    ) {
      this.loadData(newProps.data);
    }
  }

  async componentDidMount() {
    if (this.props.parametroUrl) {
      this.props.model.value = this.props.parametroUrl;
    }
    if (this.props.model.value) {
      var labelKey = this.props.model.value[this.props.labelKey];
      var valueKey = this.props.model.value[this.props.valueKey];
      if (!labelKey && valueKey) {
        // busca a descricao do lookup caso seja passado somente o ID
        var response = await httpSelector
          .getHttp(this.props.viewType)
          .post(`${this.props.url}/Search`, {
            id: valueKey,
          });
        var returnValue = response.data.list.find((v) => v.id == valueKey);
        if (returnValue) {
          this.props.model.requestChange &&
            this.props.model.requestChange(returnValue);
        }
      }
    }

    if (
      this.props.url &&
      ((!this.props.ignoreURLWithOptions &&
        this.props.options &&
        this.props.options.length > 0) ||
        !this.props.options)
    )
      this.loadData(this.props.data);
  }

  // Remove listeners e rAF pendente para não vazar referências no unmount (scroll/resize no document/window).
  componentWillUnmount() {
    this.detachMenuPortalScrollSync();
  }

  //  react-select-v2 MenuPortal só recalcula top/left no render; sem isso o menu desalinha ao scrolar.
  flushMenuPortalPosition() {
    if (this._menuPortalRaf != null) return;
    this._menuPortalRaf = requestAnimationFrame(() => {
      this._menuPortalRaf = null;
      // O ref do export default é o StateManager HOC; .select encadeia até a instância real do Select (Creatable idem). Só ela renderiza o MenuPortal.
      let selectInstance = this.selectWrapperRef;
      while (selectInstance && selectInstance.select) {
        selectInstance = selectInstance.select;
      }
      if (selectInstance && typeof selectInstance.forceUpdate === 'function') {
        selectInstance.forceUpdate();
      }
    });
  }

  attachMenuPortalScrollSync() {
    if (this._menuPortalListening) return;
    this._menuPortalListening = true;
    document.addEventListener('scroll', this.flushMenuPortalPosition, true);
    window.addEventListener('resize', this.flushMenuPortalPosition);
  }

  detachMenuPortalScrollSync() {
    if (!this._menuPortalListening) return;
    this._menuPortalListening = false;
    document.removeEventListener('scroll', this.flushMenuPortalPosition, true);
    window.removeEventListener('resize', this.flushMenuPortalPosition);
    if (this._menuPortalRaf != null) {
      cancelAnimationFrame(this._menuPortalRaf);
      this._menuPortalRaf = null;
    }
  }

  handleSelectMenuOpen() {
    this.props.onMenuOpen?.();
    this.attachMenuPortalScrollSync();
  }

  handleSelectMenuClose() {
    this.props.onMenuClose?.();
    this.detachMenuPortalScrollSync();
  }

  loadData(data) {
    httpSelector
      .getHttp(this.props.viewType)
      .post(`${this.props.url}/Search`, {
        filter: data,
        pageSize: this.props.pageSize,
      })
      .then((response) => {
        this.setState({
          data: response?.data?.list,
        });

        this.props.getDataLookup &&
          this.props.getDataLookup(response?.data?.list);

        if (
          this.props.selectFirstValue &&
          !this.props.model.value &&
          response?.data?.list &&
          response.data.list.length > 0
        )
          this.props.model.requestChange &&
            this.props.model.requestChange(response.data.list[0]);
      });
  }

  handleChange(value) {
    this.props.model.requestChange && this.props.model.requestChange(value);
  }

  handleChangeCreatable(value) {
    let isNew = value && value.isNew;

    if (this.props.multi && value && value.length > 0) {
      isNew = value && value[value.length - 1].isNew;
    }

    if (isNew) {
      this.handleNewClick(value);
    } else {
      this.handleChange(value);
    }
  }

  getDescricaoMulti(list) {
    return list.map((item) => item[this.props.labelKey]).join('; ');
  }

  renderMulti(item) {
    if (this.props.valueComponent) return this.props.valueComponent();
    else {
      if (this.props.multi) {
        return (
          <ItemMulti
            disabled={this.props.disabled}
            label={item.value[this.props.labelKey]}
            onRemove={item.onRemove.bind(this, item.value)}
            multi={this.props.multi}
          ></ItemMulti>
        );
      } else {
        return (
          <div className="Select-value">
            <span className="Select-value-label">
              {item.value[this.props.labelKey]}
            </span>
          </div>
        );
      }
    }
  }

  renderOption(item) {
    if (this.props.valueComponent) {
      return (
        <components.Option {...item}>
          {this.props.valueComponent(item, true)}
        </components.Option>
      );
    } else {
      return <components.Option {...item}>{item.children}</components.Option>;
    }
  }

  singleValue(item) {
    if (this.props.valueComponent) {
      return (
        <components.SingleValue {...item}>
          {this.props.valueComponent(item)}
        </components.SingleValue>
      );
    } else {
      return (
        <components.SingleValue {...item}>
          {item.children}
        </components.SingleValue>
      );
    }
  }

  renderMultiValue(item) {
    if (this.props.valueComponent) {
      return (
        <components.MultiValue {...item}>
          {this.props.valueComponent(item)}
        </components.MultiValue>
      );
    } else {
      return (
        <components.MultiValue {...item}>{item.children}</components.MultiValue>
      );
    }
  }

  handleNewClick(value) {
    const data = this.props.data || {};
    ContentManager.addContent(
      <this.props.editComponent
        parameters={{ ...data, nome: value[this.props.labelKey] }}
        handleClose={this.handleClose}
        {...this.props?.propsEdit}
      />
    );
  }

  handleClose(saved, id) {
    if (saved) {
      this.loadData(this.props.data);

      httpSelector
        .getHttp(this.props.viewType)
        .get(`${this.props.url}/Get`, {
          params: {
            id: id,
          },
        })
        .then((response) => {
          if (this.props.selectNewItem) {
            this.toggleItem(response.data);
          }
        });
    }
  }

  toggleItem(item) {
    if (this.props.multi && item) {
      const lista = this.props.model && this.props.model.value;
      lista.push(item);
      this.props.model.requestChange(lista);
    } else {
      this.props.model.requestChange(item);
    }
  }

  getValue(objectValue, model) {
    if (
      (objectValue && !objectValue[this.props.labelKey]) ||
      (!this.props.multi &&
        model &&
        model.value &&
        !model.value[this.props.labelKey])
    ) {
      return this.state.data
        ? objectValue
          ? this.state.data.find(
              (x) => x[this.props.valueKey] == objectValue[this.props.valueKey]
            )
          : this.state.data.find(
              (x) =>
                x[this.props.valueKey] ==
                (model.value[this.props.valueKey] ?? model.value)
            )
        : objectValue || model.value;
    } else return objectValue || model.value;
  }

  getOptionLabel(option) {
    if (this.props.moduloLookup && option.nomeExibicao) {
      return `${option.nomeExibicao} - ${option.nome}`;
    }
    return option[this.props.labelKey];
  }

  getOptionValue(option) {
    return option[this.props.valueKey];
  }

  CustomMultiValueLabel = (props) => {
    if (this.props.renderLabelMulti) {
      return (
        <components.MultiValueLabel {...props}>
          {this.props.renderLabelMulti(props.data)}
        </components.MultiValueLabel>
      );
    }

    return (
      <components.MultiValueLabel {...props}>
        {props.data[this.props.labelKey]}
      </components.MultiValueLabel>
    );
  };

  CustomMenuList = (props) => {
    const labelStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      marginBottom: 4,
      cursor: 'pointer',
    };

    const titleStyle = {
      fontWeight: 600,
      fontSize: 12,
      margin: 0,
    };

    const descriptionStyle = {
      fontSize: 11,
      marginLeft: 0,
      marginTop: -2,
      color: '#6c757d',
    };

    const { intl, modelConditional } = this.props;
    const tipoCondicional = modelConditional?.value ?? {
      id: 2,
      descricao: intl.formatMessage({ id: 'contem' }),
    };

    return (
      <components.MenuList {...props}>
        <div style={{ maxHeight: 120, overflowY: 'auto' }}>
          {props.children}
        </div>

        <div
          style={{
            maxHeight: 100,
            padding: '6px',
            borderTop: '1px solid #ccc',
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 4 }}>
            {intl.formatMessage({ id: 'condicional' })}
          </div>

          <label style={labelStyle}>
            <input
              type="radio"
              name="condition"
              value="1"
              checked={tipoCondicional.id === 1}
              onChange={() =>
                modelConditional.requestChange &&
                modelConditional.requestChange({
                  id: 1,
                  descricao: intl.formatMessage({ id: 'igual' }),
                })
              }
            />
            <div>
              <div className="text-primary" style={titleStyle}>
                {intl.formatMessage({ id: 'igual' })}
              </div>
              <div style={descriptionStyle}>
                {intl.formatMessage({ id: 'label.todasOpcoesVerdadeiras' })}
              </div>
            </div>
          </label>

          <label style={labelStyle}>
            <input
              type="radio"
              name="condition"
              value="2"
              checked={tipoCondicional.id === 2}
              onChange={() =>
                modelConditional.requestChange &&
                modelConditional.requestChange({
                  id: 2,
                  descricao: intl.formatMessage({ id: 'contem' }),
                })
              }
            />
            <div>
              <div className="text-primary" style={titleStyle}>
                {intl.formatMessage({ id: 'contem' })}
              </div>
              <div style={descriptionStyle}>
                {intl.formatMessage({ id: 'label.umaOpcaoVerdadeira' })}
              </div>
            </div>
          </label>
        </div>
      </components.MenuList>
    );
  };

  render() {
    let {
      model,
      multi,
      valueKey,
      labelKey,
      options,
      optionRenderer,
      valueRenderer,
      clearable,
      disabled,
      placeholder = '',
      required,
      style,
      autoFocus,
      editComponent,
      intl,
      row,
      showLabel,
      objectValue,
      menuPlacement,
      customStyle,
      menuPosition,
      controlStyle = {},
      compactMulti,
      showConditional,
      showHint = false,
      hintPosition = 'bottom',
      idHint,
      labelHint,
      'data-testid': dataTestId,
      ...other
    } = this.props;
    const customComponents = {};

    if (this.props.showConditional) {
      customComponents.MenuList = this.CustomMenuList;
    }

    if (this.props.valueComponent) {
      customComponents.Option = this.renderOption;
      customComponents.SingleValue = this.singleValue;
      customComponents.MultiValue = this.renderMultiValue;
      customComponents.MultiValueLabel = this.CustomMultiValueLabel;
    }

    if (compactMulti && multi) {
      customComponents.ValueContainer = CompactMultiValueContainer;
    }

    return (
      <FormGroup
        noMargin={style?.marginBottom == 0}
        className="form-group"
        data-testid={dataTestId}
        row={row}
        validationstate={model.errors ? 'error' : null}
        style={style}
      >
        {showLabel && model.label && (
          <div
            className="pb-2"
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CopyToClipboard
              text={model.label}
              required={required}
              value={model.value}
            />
            {showHint && (
              <Info
                id={idHint}
                className="pl-1 mb-1"
                placement={hintPosition}
                text={labelHint}
              />
            )}
          </div>
        )}
        {editComponent ? (
          <CreatableSelect
            styles={{
              ...customStyle,
              ...(compactMulti && multi && compactMultiStyles),
              control: (base) => ({
                ...base,
                ...(compactMulti && multi && { height: 38, minHeight: 38 }),
                borderColor:
                  required && model.errors != null && model.errors != ''
                    ? '#f05050'
                    : '#dde6e9',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 200003 }),
            }}
            menuPortalTarget={document.body}
            classNames={{ menuPortal: () => 'select-menu-portal' }}
            getOptionLabel={this.getOptionLabel}
            getOptionValue={this.getOptionValue}
            getNewOptionData={(inputValue, optionLabel) => ({
              [valueKey]: inputValue,
              [labelKey]: optionLabel,
              isNew: true,
            })}
            isDisabled={disabled}
            autoFocus={autoFocus}
            valueComponent={this.renderMulti}
            clearValueText={intl.formatMessage({ id: 'label.limparValor' })}
            formatCreateLabel={(label) => (
              <a tabIndex="-1">
                {intl.formatMessage(
                  { id: 'label.cliqueAquiParaCriarLabel' },
                  { label: label }
                )}
              </a>
            )}
            isClearable={clearable}
            valueRenderer={valueRenderer}
            optionRenderer={optionRenderer}
            onChange={this.handleChangeCreatable}
            isMulti={multi}
            placeholder={placeholder}
            menuPlacement={menuPlacement}
            components={customComponents}
            menuPosition={menuPosition}
            className={this.state.classes.select}
            value={model.value}
            options={options || this.state.data}
            closeMenuOnSelect={!showConditional}
            {...other}
            ref={(r) => {
              this.selectWrapperRef = r;
            }}
            onMenuOpen={this.handleSelectMenuOpen}
            onMenuClose={this.handleSelectMenuClose}
          />
        ) : (
          <Select
            styles={{
              ...customStyle,
              ...(compactMulti && multi && compactMultiStyles),
              control: (base) => ({
                ...base,
                ...controlStyle,
                ...(compactMulti && multi && { height: 38, minHeight: 38 }),
                borderColor:
                  required && model.errors != null && model.errors != ''
                    ? '#f05050'
                    : '#dde6e9',
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 200003,
              }),
            }}
            getOptionValue={this.getOptionValue}
            getOptionLabel={this.getOptionLabel}
            menuPortalTarget={document.body}
            classNames={{ menuPortal: () => 'select-menu-portal' }}
            isDisabled={disabled}
            components={customComponents}
            autoFocus={autoFocus}
            clearValueText={intl.formatMessage({ id: 'label.limparValor' })}
            noOptionsMessage={() =>
              intl.formatMessage({ id: 'label.nenhumRegistroEncontrado' })
            }
            isClearable={clearable}
            onChange={this.handleChange}
            isMulti={multi}
            className={this.state.classes.select}
            value={this.getValue(objectValue, model)}
            options={options || this.state.data}
            placeholder={placeholder}
            menuPlacement={menuPlacement}
            menuPosition={menuPosition}
            closeMenuOnSelect={!showConditional}
            {...other}
            ref={(r) => {
              this.selectWrapperRef = r;
            }}
            onMenuOpen={this.handleSelectMenuOpen}
            onMenuClose={this.handleSelectMenuClose}
          />
        )}
        {model.erros && <FormFeedback>{model.erros}</FormFeedback>}
      </FormGroup>
    );
  }
}
function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    viewType: state.viewType,
  };
}
export default injectIntl(connect(mapStateToProps)(Select2));
